import React from 'react';

/**
 * OffersEmpty — role-aware empty state. Reuses .ui-empty from ui.css.
 */
export default function OffersEmpty({
  role = 'buyer',
  hasFilters = false,
  onClearFilters,
  onCreate,
}) {
  let emoji;
  let heading;
  let body;
  let actionLabel = null;
  let actionHandler = null;

  if (hasFilters) {
    emoji = '🔍';
    heading = 'No offers match your filters';
    body = 'Try clearing the search or status filter.';
    if (typeof onClearFilters === 'function') {
      actionLabel = 'Clear filters';
      actionHandler = onClearFilters;
    }
  } else if (role === 'buyer') {
    emoji = '📭';
    heading = 'No offers yet';
    body = 'Create your first offer to get started.';
    if (typeof onCreate === 'function') {
      actionLabel = 'Make an offer';
      actionHandler = onCreate;
    }
  } else {
    emoji = '🏠';
    heading = 'No offers received yet';
    body = "When buyers make offers on your listings, they'll appear here.";
  }

  return (
    <div className="ui-empty offers-empty">
      <div className="offers-empty__emoji" aria-hidden="true" style={{ fontSize: 40, marginBottom: 8 }}>
        {emoji}
      </div>
      <h3
        className="offers-empty__heading"
        style={{ margin: '0 0 8px', color: 'var(--color-text-primary)', fontSize: 18 }}
      >
        {heading}
      </h3>
      <p className="offers-empty__body" style={{ margin: '0 0 16px' }}>
        {body}
      </p>
      {actionLabel && actionHandler ? (
        <button
          type="button"
          className="btn btn-primary offers-empty__action"
          onClick={actionHandler}
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
